export interface IDashboardActionsData{
    total: number;
    notStarted: number;
    inProgress: number;
    dueDateExpired: number;
    finished: number;
    group?: number;
    draft: number;
    canceled: number;
    title?: string;
}

export const colorChart = [
	"var(--purple)",
	"var(--blue)",
	"var(--red)",
	"var(--green)",
	"var(--grey)",
	"var(--default-color-font)"
];

export interface IDashboardActionsDataChart extends IDashboardActionsData{
    color: any;
    name: string;
}

export interface IDashboardActionsDataPieChart{
    name: string;
    value: number;
}
